import React, { Component } from 'react';
import { connect } from "react-redux";
import CustomSelect from "../../components/common/select/Select";
import DATA from '../../assets/data';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import TopActivitiesPratDashboardTable from '../../components/tables/topActivitiesPratDashboardTable';
import PratDashboardMiddleware from '../../store/prat_middleware/pratDashboard/pratDashboardMiddleware';
import { compare } from '../gt/validation/sort';
import CustomToast from '../../util-functions/customToast.jsx'

class TopActivitiesTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCategory: [],
            selectedBrands: [],
            data: [],
            myBrands: [],
            selectedWeekFrom: "",
            selectedWeekTo: "",
            promotionTypes: DATA.PROMO_TYPES
        };
    }

    componentDidMount() {
        let arr = []
        if(this.props.categories){
            this.props.categories.forEach(item => {
                arr.push(item.guid)
            })
            this.setState({
                selectedCategory: arr
            }, () => {
                this.handleSubmit();
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.categories !== this.props.categories) {
            let arr = []
            this.props.categories.forEach(item => {
                arr.push(item.guid)
            })
            this.setState({
                selectedCategory: arr
            }, () => {
                this.handleSubmit();
            })
        }

        if (prevProps.brands !== this.props.brands) {
            this.handleFilteredBrands()
        }
    }

    handleCategory = (category) => {
        let arr = [];
        if (category === null || category.length === 0) {
            this.setState({
                selectedCategory: [],
                myBrands: [],
                selectedBrands: []
            }, () => {
                this.handleSubmit();
            });
        } else {
            category.forEach((element) => {
                arr.push(element.value);
            });
            this.setState({
                selectedCategory: arr,
                selectedBrands: []
            }, () => {
                this.handleFilteredBrands();
                this.handleSubmit();
            });
        }
    };

    handleFilteredBrands = () => {
        const {
            selectedCategory,
            myBrands,
            selectedBrands,
        } = this.state;
        const { brands } = this.props;
        let filteredbrands = [];
        if (selectedCategory.length) {
            for (let i = 0; i < selectedCategory.length; i++) {
                filteredbrands.push(
                    ...brands.filter((item) => {       // eslint-disable-line
                        if (item.CustomCategory === selectedCategory[i]) {
                            item.checked = false
                            return item;
                        }
                    })
                );
            }

            this.setState({
                myBrands: filteredbrands,
            });
            let arr = [];
            if (selectedBrands.length !== 0) {
                myBrands.forEach((element) => {
                    selectedBrands.forEach((e, i) => {
                        if (element.guid === e) {
                            arr.push(e);
                            this.setState({ selectedBrands: arr });
                        } else {
                        }
                    });
                });
            }
        }
    };

    handleWeekFromChange = (selectedValue) => {
        if (selectedValue) {
            this.setState({
                selectedWeekFrom: selectedValue.value,
                selectedWeekTo: "",
            }, () => {
                this.handleSubmit();
            });
        } else {
            this.setState({
                selectedWeekFrom: "",
                selectedWeekTo: "",
            }, () => {
                this.handleSubmit();
            });
        }
    };

    handleWeekToChange = (selectedValue) => {
        if (selectedValue) {
            this.setState({
                selectedWeekTo: selectedValue.value,
            }, () => {
                this.handleSubmit();
            });
        } else {
            this.setState({
                selectedWeekTo: "",
            }, () => {
                this.handleSubmit();
            });
        }
    };

    handleBrandCheck = (e, ind) => {
        this.state.myBrands[ind].checked = !this.state.myBrands[ind].checked       // eslint-disable-line
        this.setState({
            myBrands: this.state.myBrands
        },
            () => {
                let filterCheckedValues = []
                this.state.myBrands.forEach(item => {
                    if (item.checked) {
                        filterCheckedValues.push(item.guid)
                    }
                })
                this.setState({
                    selectedBrands: filterCheckedValues
                }, () => {
                    this.handleSubmit();
                })
            })
    }

    handlePromoTypeCheck = (e, ind) => {
        this.state.promotionTypes[ind].topActivitiesChecked = !this.state.promotionTypes[ind].topActivitiesChecked       // eslint-disable-line
        this.setState({
            promotionTypes: this.state.promotionTypes
        },
            () => {
                let filterCheckedValues = []
                this.state.promotionTypes.forEach(item => {
                    if (item.topActivitiesChecked) {
                        filterCheckedValues.push(item.guid)
                    }
                })
                this.setState({
                    selectedPromoType: filterCheckedValues
                }, () => {
                    this.handleSubmit();
                })
            })
    }

    handleSubmit = () => {
        if (this.state.selectedCategory.length) {
            this.props.getTopActivites(
                this.state.selectedCategory,
                this.state.selectedPromoType,
                this.state.selectedBrands,
                this.state.selectedWeekFrom,
                this.state.selectedWeekTo
            )
        } else {
            // ToastsStore.error('Category is not selected!')
            CustomToast('error', 'Category is not selected!')
        }
    }

    render() {
        return (
            <div className='activation-metrics-container' style={{ minHeight: '250px' }}>

                <div className='activation-metrics-heading-cta'>

                    <span className='activation-metrics-heading'></span>

                    <span style={{ flexGrow: '1' }}></span>

                    <CustomSelect.MyCustomSelect
                        className='filter-font-size'
                        placeholder={"Category"}
                        allowSelectAll={true}
                        isMulti
                        options={
                            this.props.categories
                                ? !this.props.categories
                                    ? void 0
                                    : this.props.categories.sort(compare).map(item => ({
                                        value: item.guid,
                                        label: item.Name
                                    }))
                                : []
                        }
                        onChange={this.handleCategory}
                        value={
                            this.props.categories
                                ? this.props.categories
                                    .filter(item => {
                                        return !this.state.selectedCategory
                                            ? void 0
                                            : this.state.selectedCategory.includes(item.guid);
                                    })
                                    .map(item => {
                                        return {
                                            value: item.guid,
                                            label: item.Name
                                        };
                                    }) : void 0
                        }
                    />
                    <span style={{ flexGrow: '1' }}></span>
                    <CustomSelect.MyCustomSelect
                        className="select-box filter-font-size"
                        placeholder="Week From"
                        isClearable={true}
                        options={DATA.WEEK_NO.map((item) => ({
                            value: item.value,
                            label: item.label,
                        }))}
                        onChange={this.handleWeekFromChange}
                        value={
                            DATA.WEEK_NO
                                ? DATA.WEEK_NO.filter((item) => {
                                    return !this.state.selectedWeekFrom
                                        ? void 0
                                        : item.value === this.state.selectedWeekFrom;
                                }).map((item) => {
                                    return {
                                        value: item.value,
                                        label: item.label,
                                    };
                                })
                                : void 0
                        }
                    />
                    <CustomSelect.MyCustomSelect
                        className="select-box filter-font-size"
                        placeholder="Week To"
                        isClearable={true}
                        options={
                            this.state.selectedWeekFrom
                                ? DATA.WEEK_NO.filter((item) => {
                                    return item.value >= this.state.selectedWeekFrom;
                                }).map((item) => ({
                                    value: item.value,
                                    label: item.label,
                                }))
                                : []
                        }
                        onChange={this.handleWeekToChange}
                        value={
                            DATA.WEEK_NO
                                ? DATA.WEEK_NO.filter((item) => {
                                    return !this.state.selectedWeekTo
                                        ? void 0
                                        : item.value === this.state.selectedWeekTo;
                                }).map((item) => {
                                    return {
                                        value: item.value,
                                        label: item.label,
                                    };
                                })
                                : void 0
                        }
                    />
                    <div className='cta-container'>
                        <div className='funnel-filter-container'>
                            <img alt='' className='funnel-filter-image' src={require('../../assets/images/funnelFilter.svg')} onClick={() => { this.setState({ popUp: !this.state.popUp }) }} />
                            {/* Funnel Icon Popup Filter */}
                            {this.state.popUp ?
                                <ClickAwayListener onClickAway={() => { this.setState({ popUp: false }) }}>

                                    <div className='funnel-pop-up' style={{ width: 'max-content', overflowY: 'auto', height: '208px' }}>

                                        <div className='popUp-columns' style={{ paddingRight: '10px' }}>
                                            <span className='popUp-heading'>Type of Promo</span>

                                            <div className='promo-column'>
                                                {this.state.promotionTypes.map((item, indx) => (
                                                    <span className='column-item' key={indx}>
                                                        <input type='checkbox' className='column-item-input' checked={item.topActivitiesChecked}
                                                            onChange={(e) => this.handlePromoTypeCheck(e, indx)} />
                                                        <label>{item.Label}</label>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading' style={{ paddingRight: '112px' }}>Brands</span>
                                            <div className='promo-column'>
                                                {
                                                    this.state.myBrands.map((item, indx) => (
                                                        <span className='column-item' key={indx}>
                                                            <input type='checkbox' className='column-item-input' checked={item.checked}
                                                                onChange={(e) => this.handleBrandCheck(e, indx)} />
                                                            <label>{item.Name}</label>
                                                        </span>
                                                    ))
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </ClickAwayListener>
                                :
                                null
                            }
                        </div>
                        <img alt='' className='images-style' src={require('../../assets/images/refreshArrows.svg')} onClick={this.handleSubmit} />
                        <img alt='' className='image-transform' src={require('../gt/images/dots.png')} />
                    </div>

                </div>

                {this.props.isTopTenActivitiesLoading ?
                    <div style={{ marginTop: '100px' }}>
                        <img alt='' src={require('../../assets/images/barsLoader.svg')} style={{ width: '60px', height: '60px' }} />
                    </div>
                    :
                    <>
                        <TopActivitiesPratDashboardTable data={this.props?.topTenActivities?.Top} heading='Pre OPSO - Top 5 Activities' />
                        <TopActivitiesPratDashboardTable data={this.props?.topTenActivities?.Bottom} heading='Pre OPSO - Bottom 5 Activities' />
                    </>
                }


            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        topTenActivities: state.PratDashboardReducer.topTenActivities,
        isTopTenActivitiesLoading: state.PratDashboardReducer.isTopTenActivitiesLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTopActivites: (
            selectedCategory,
            selectedPromoType,
            selectedBrands,
            selectedWeekFrom,
            selectedWeekTo
        ) => {
            return dispatch(PratDashboardMiddleware.getTopActivites(
                selectedCategory,
                selectedPromoType,
                selectedBrands,
                selectedWeekFrom,
                selectedWeekTo
            ));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TopActivitiesTable);
